<template>
  <v-navigation-drawer v-bind="$attrs" :mini-variant.sync="mini">
    <template v-slot:prepend>
      <v-toolbar flat dense v-if="!mini">
        <v-toolbar-title class="subtitle-1">Template settings</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon small @click="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>

      <v-btn class="mt-2" icon small @click="mini = !mini" v-else>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-divider v-show="!mini"></v-divider>

      <v-toolbar flat dense v-if="tabs.length" v-show="!mini">
        <v-tabs v-model="currentTab" color="secondary">
          <v-tab v-for="tab in tabs" :key="tab" small>{{ tab }}</v-tab>
        </v-tabs>
      </v-toolbar>

      <v-divider v-if="tabs.length" v-show="!mini"></v-divider>
    </template>

    <v-form v-model="valid" v-show="!mini">
      <v-card
        flat
        tile
        :loading="$apollo.loading || drawer.loading"
        :disabled="$apollo.loading || drawer.loading"
      >
        <v-card-text class="pa-0">
          <v-tabs-items v-model="currentTab">
            <v-tab-item eager v-for="tab in tabs" :key="tab">
              <div class="editor-form-fields">
                <div
                  class="uncategorized-fields px-4 pt-6"
                  v-if="
                    Object.keys(getFieldsByCategory(formFields[tab])).length
                  "
                >
                  <component
                    v-for="(field, index) in getFieldsByCategory(
                      formFields[tab]
                    )"
                    :key="index"
                    :is="`${field.type}-field`"
                    :field="field"
                    :value.sync="activeTemplate[tab][index]"
                    v-track-changes-once
                  ></component>
                </div>

                <v-expansion-panels
                  accordion
                  hover
                  tile
                  flat
                  class="elevation-0"
                  focusable
                >
                  <v-expansion-panel
                    style="margin-right: 2px"
                    class="categorized-fields"
                    v-for="(category, index) in fieldCategories(
                      formFields[tab]
                    )"
                    :key="index"
                  >
                    <v-divider
                      v-if="
                        index == 0 &&
                          Object.keys(getFieldsByCategory(formFields[tab]))
                            .length
                      "
                    ></v-divider>

                    <v-expansion-panel-header
                      style="min-height:0"
                      class="subtitle-2"
                      >{{ category }}</v-expansion-panel-header
                    >

                    <v-expansion-panel-content color="transparent" class="pt-2">
                      <component
                        v-for="(field, index) in getFieldsByCategory(
                          formFields[tab],
                          category
                        )"
                        :key="index"
                        :is="`${field.type}-field`"
                        :field="field"
                        :value.sync="activeTemplate[tab][index]"
                        v-track-changes-once
                      ></component>
                    </v-expansion-panel-content>

                    <v-divider></v-divider>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-form>

    <template v-slot:append v-show="!mini">
      <v-toolbar flat dense v-if="!valid">
        <v-spacer></v-spacer>

        <span class="error--text"
          >Please make sure that all fields are valid.</span
        >
      </v-toolbar>

      <v-divider></v-divider>

      <v-toolbar flat dense>
        <v-spacer></v-spacer>
        <v-btn
          text
          class="mr-2"
          color="success"
          @click="save(false)"
          :disabled="!drawer.changed || !valid || drawer.loading"
          >Save</v-btn
        >

        <v-btn
          text
          class="mr-2"
          color="warning"
          @click="save(true)"
          :disabled="!drawer.changed || !valid || drawer.loading"
          >Save & close</v-btn
        >
        <v-btn
          text
          color="error"
          :disabled="drawer.loading"
          @click="closeEditor()"
          >Close</v-btn
        >
      </v-toolbar>
    </template>
  </v-navigation-drawer>
</template>

<script>
import formFields from './form-fields'
import { activeTemplate, upsertTemplate } from '@/graphql/template.gql'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TemplateSettings',
  data: () => ({
    valid: false,
    mini: false,
    currentTab: null,
    formFields,
    activeTemplate: {
      content: {},
      design: {},
      layout: {},
      advanced: {}
    }
  }),
  computed: {
    ...mapState('editor', ['drawer']),
    tabs() {
      return Object.keys(this.formFields).filter(
        key => Object.keys(this.formFields[key]).length
      )
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate,
      result({ data }) {
        // watch design properties and update style
        Object.keys(data.activeTemplate.design).forEach(key => {
          this.$watch(
            () => data.activeTemplate.design[key],
            newValue => {
              document.documentElement.style.setProperty(`--${key}`, newValue)
            }
          )
        })

        this.drawer.changed = false
      }
    }
  },
  methods: {
    ...mapActions('editor', ['closeEditor', 'saveChanges']),
    save(close) {
      this.saveChanges({
        mutation: upsertTemplate,
        variables: {
          data: {
            id: this.activeTemplate.id,
            name: this.activeTemplate.name,
            description: this.activeTemplate.description,
            content: this.activeTemplate.content,
            design: this.activeTemplate.design,
            layout: this.activeTemplate.layout,
            advanced: this.activeTemplate.advanced
          }
        },
        messages: {
          success: 'Template settings successfully updated.'
        },
        refetch: false,
        close
      })
    }
  }
}
</script>
